/** Error normalizado: la UI nunca ve el detalle de transporte. */
export interface AppError {
  readonly kind: 'red' | 'autenticacion' | 'permiso' | 'validacion' | 'servidor' | 'desconocido';
  readonly message: string;
  readonly status?: number;
}

const MENSAJES: Readonly<Record<AppError['kind'], string>> = {
  red: 'Sin conexión con el servidor. Revisa tu internet e inténtalo de nuevo.',
  autenticacion: 'Tu sesión expiró. Vuelve a iniciar sesión.',
  permiso: 'No tienes permiso para realizar esta acción.',
  validacion: 'Revisa los datos ingresados.',
  servidor: 'El servidor tuvo un problema. Inténtalo en unos minutos.',
  desconocido: 'Ocurrió un error inesperado.',
};

export function toAppError(error: unknown): AppError {
  if (isHttpError(error)) {
    const kind = kindFromStatus(error.status);
    return {
      kind,
      status: error.status,
      message: serverMessage(error) ?? MENSAJES[kind],
    };
  }
  if (error instanceof TypeError) {
    return { kind: 'red', message: MENSAJES.red };
  }
  return { kind: 'desconocido', message: MENSAJES.desconocido };
}

function kindFromStatus(status: number): AppError['kind'] {
  if (status === 401) return 'autenticacion';
  if (status === 403) return 'permiso';
  if (status === 422 || status === 400) return 'validacion';
  if (status >= 500) return 'servidor';
  return 'desconocido';
}

interface HttpLikeError {
  readonly status: number;
  readonly data?: unknown;
}

function isHttpError(error: unknown): error is HttpLikeError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    typeof (error).status === 'number'
  );
}

/** Mensaje del API si viene en un formato conocido; nunca un volcado crudo. */
function serverMessage(error: HttpLikeError): string | undefined {
  const data = error.data;
  if (typeof data !== 'object' || data === null) {
    return undefined;
  }
  const candidato =
    (data as { message?: unknown }).message ??
    (data as { error?: { message?: unknown } }).error?.message;
  return typeof candidato === 'string' && candidato.trim().length > 0
    ? candidato
    : undefined;
}
